var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeracityadsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 349.6 166.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#525252;}.cls-2{fill:#4bad38;}.cls-3{fill:#0093bb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,111.65H8.29l10.14,25.46,10.14-25.46h8.29l-18.43,42.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262,110.72l18.42,42.5h-8.28L262,127.76l-10.15,25.46h-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.77,146.32c-3.84,4.84-9.14,7.76-14.91,7.83-11.21,0-17.7-8.43-17.7-16.91s6.49-16.91,17.7-16.91c6.69,0,16.64,5.5,16.64,18v1.25H41.85c.4,4.91,5,8.43,9.81,8.43a11.43,11.43,0,0,0,9.28-5Zm-6.36-12.4c-1.46-4.91-5.1-7.49-9.48-7.49s-8,2.72-9.08,7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.67,121.19h6.5v3.52h.13a6.88,6.88,0,0,1,6.31-4.38,7,7,0,0,1,3.77,1l-2.45,6.83a5.11,5.11,0,0,0-2.59-.93,4.72,4.72,0,0,0-4.77,4.84v21.21h-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.55,149.37h-.13a13.17,13.17,0,0,1-10.54,4.78c-10.54,0-16.64-8.63-16.64-16.91,0-7.89,6.56-16.91,17-16.91,4.77,0,8.42,2,10.21,4.78h.13v-3.92h6.9v32.09h-6.9Zm-9.81-1.72a10.41,10.41,0,1,0-10.21-10.41A10.32,10.32,0,0,0,110.74,147.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.68,131.67c-1.86-2.85-4.44-4.84-8.36-4.84a10.41,10.41,0,0,0,0,20.82,9.59,9.59,0,0,0,8.36-4.84l6,3.58a17.18,17.18,0,0,1-14.39,7.76c-11.2,0-17.7-8.43-17.7-16.91s6.5-16.91,17.7-16.91c6.83,0,11.27,3.25,14.39,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.52,110.79a3.85,3.85,0,1,1-3.84,3.84A3.84,3.84,0,0,1,175.52,110.79Zm-3.44,10.4H179v32.09h-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.53,121.19h3.91v-8.48l6.9-1.92v10.4h5.5v6.5h-5.5v12.67c0,3.44.79,5,2.85,6.23l3.71,2.12-3.05,5.44c-7.1-3.39-10.41-5.84-10.41-12.54V127.69h-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.67,121.19h6.89V140c0,5.38,3.31,7.63,7.56,7.63,5.37,0,7.95-3.32,7.95-8.29V121.19H238v31.1c0,9.81-8.69,14.12-14.65,14.12-7.23,0-10.48-2.72-13.59-6.3l5.83-3.58c2.19,2.13,4.37,3.38,7.36,3.38,4.58,0,8.55-2.78,8.55-8.41v-1.73h-.13a11.44,11.44,0,0,1-9.68,4.38c-7.16,0-13-5.38-13-14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.9,149.37h-.13a13.17,13.17,0,0,1-10.54,4.78c-10.54,0-16.64-8.63-16.64-16.91,0-7.89,6.56-16.91,17-16.91,4.77,0,8.42,2,10.21,4.78h.13V111.65h6.9v41.63h-6.9Zm-9.81-1.72a10.41,10.41,0,1,0-10.21-10.41A10.32,10.32,0,0,0,299.09,147.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.26,143.74a14.88,14.88,0,0,0,10.08,4.7c4,0,6.36-2.25,6.36-4,0-2.13-1.65-3.25-4.17-3.72l-3.91-.72c-9-1.66-11.54-4.58-11.54-9.15,0-5.44,4.58-10.48,12.6-10.48,4.44,0,8.35,1.33,12.73,4.44l-3.92,4.85c-3.38-2.86-6.36-3.58-8.61-3.58-3,0-5.9,1.45-5.9,4,0,1.92,1.52,2.91,4.17,3.38l7,1.33c5.71,1.06,8.49,3.77,8.49,8.54s-3.85,10.82-13.59,10.82a21.57,21.57,0,0,1-14.45-5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.13,37c-4.77-8.36-11.85-12.82-21.41-13s-16.67,4.41-21.4,12.8L172.38,84.7l16.49,0,23.51-40.95c4.64-8,14-8,18.68,0l15.46,27.05H230.09l-8.45-14.76-7.93,14.22L222,84.72l48.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.12,8.58a24.74,24.74,0,0,0-40.18,3.83L151.22,65.3c-4.41,7.58-13.88,7.56-18.3,0L103.06,13.9c4.71,0,11.31,0,16.71,0l23,38.17,8.27-14.29L128.05,0H78.89l41.83,71.85c4.48,7.83,11,12.19,19.7,12.78,0,0,0,0,0,0h.87c.3,0,.61,0,.91,0,9.56.09,16.47-4.43,21.21-12.71l28-48.43C196.25,15.27,203.11,9.81,213,9.37c3.46-.16,7,.75,10.6,1.19C223.16,10,222.68,9.23,222.12,8.58Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeracityadsLogo);
export default __webpack_public_path__ + "static/media/veracityads-logo.71f7dee9c4434fc71ba2cfb6ba4cf58b.svg";
export { ForwardRef as ReactComponent };